module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-down-left-cd3b0d3a.svg";